import { IQuickLinksTab } from '../../../types/quickLinks';

const DEFAULT_TAB_NAME = 'часто ищут';

export function getDefaultTab(tabs: IQuickLinksTab[]): number {
  const defaultTab = tabs.findIndex(tab => tab.title.toLowerCase() === DEFAULT_TAB_NAME);

  return defaultTab === -1 ? 0 : defaultTab;
}
